var $ = jQuery.noConflict();

var $j3wApp = $j3wApp || {};

// Lazysizes config ------------------------------------------------------------
/*
window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.loadMode = 1; // 1 = jenom ty co jsou videt ve viewportu

// Lazysizes plugin extend
//add simple support for background images:
$(document).on('lazybeforeunveil', function(e){
    var t = e.target,
        bg = $(t).data('bg');
    if( bg ){
        $(t).css({ 'background-image' : 'url('+ bg + ')' });
    }
}); */

// J3W app ---------------------------------------------------------------------


'use strict';

var Masonry = require('masonry-layout');

if (!$.j3wThemeExtensions)
    $.j3wThemeExtensions = {};

function J3WTheme() {

    var self = this;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#header-top");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#main-menu");
    self.$mainNav = $("#main-nav");
    self.$mobileMenu = $("#mobile-menu");

    self.$photoSwipeItem = $(".photoswipe-item");

    self.$ajaxActivities = false;

    self.init();

}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        self.onBind();
        self.fancybox();

        // mozna bysme to mohli spoustet jen na strankach,
        // kterych se to tyka, ale uplne to neni treba
        self.masonrySingleGalleryInit();
        //self.masonryBlogInit();

        //if (self.$photoSwipeItem.length) {
        //    self.photoSwipeInit();
        //}

    },

    onBind: function () {

        var self = this;

        self.$window.on('scroll', function () {
            self.bodyScrollClass(self);
        });

        self.$hamburger.on("mousedown", function () {
            self.mobileMenu();
        });

    },

    mobileMenu: function () {

        var self = this, t;

        clearTimeout(t);

        self.$body.toggleClass("sideoutarea-is-open");

        var $hamburger = $(".hamburger");

        if (self.$mobileMenu.hasClass("open")) {

            self.$mobileMenu.removeClass("open");

            t = setTimeout(function () {
                $hamburger.removeClass("is-active");
            }, 200);

        } else {

            self.$mobileMenu.addClass("open");

            t = setTimeout(function () {
                $hamburger.addClass("is-active");
            }, 200);

        }

    },

    masonrySingleGalleryInit: function () {

        if ( $("#masonry-single-gallery").length ) {
            var msnr = new Masonry( "#masonry-single-gallery", {
                itemSelector: '.single-gallery-brick',
                columnWidth: '.single-gallery-grid-sizer',
                horizontalOrder: true,
                percentPosition: true,
                resize: true
            });
        }

    },
    /*
    masonryBlogInit: function() {

        $(".masonry-single-gallery").masonry({
            itemSelector: '.single-gallery-brick',
            columnWidth: '.single-gallery-grid-sizer',
            //horizontalOrder: true,
            percentPosition: true,
            resize: true
        });

    },
*/
    bodyScrollClass: function (self) {

        // potrebujeme vedet, jestli se scrolluje dolu nebo nahoru
        // nenasel jsem ekvivalent k getBoundingClientRect() v jquery

        if ((document.body.getBoundingClientRect()).top > self.scrollPos) {
            self.$body.addClass('scroll-up');
        } else {
            self.$body.removeClass('scroll-up');
        }

        self.scrollPos = (document.body.getBoundingClientRect()).top;

        if (self.$document.scrollTop() < self.$header.outerHeight() + 100) {
            self.$body.addClass('hide-menu');
        } else {
            self.$body.removeClass('hide-menu');
        }

    },

    fancybox: function () {

        $('[data-fancybox="gallery"]').fancybox({
            loop: true,
            buttons: [
                "zoom",
                "share",
                "slideShow",
                "fullScreen",
                //"download",
                //"thumbs",
                "close"
            ]
        });
    },

    photoSwipeInit: function () {

        var self = this;

        var i = 0;

        self.$photoSwipeItem.each(function () {

            $(this).attr("data-index", i);
            i++;

        });

        var items = self.photoSwipeItems(self.$photoSwipeItem);

        var $pswp = $('.pswp')[0];

        self.$photoSwipeItem.on('click', function (event) {

            var $index = $(this).data("index");
            var options = {
                index: $index,
                bgOpacity: 0.95,
                showHideOpacity: true,
                preload: [2, 2]
            };

            // Initialize PhotoSwipe
            var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);

            lightBox.init();

            event.preventDefault();

        });

    },

    photoSwipeItems: function ($figure) {

        var items = [];

        $figure.find("a").each(function () {

            var href = $(this).attr('href'),
                size = $(this).data('size') ? $(this).data('size').split('x') : [1200, 900],
                width = size[0],
                height = size[1],
                caption = $(this).closest("figure").find("figcaption").text();

            var item = {
                src: href,
                w: width,
                h: height,
                title: caption
            };

            items.push(item);

        });

        return items;

    }

};

// Add core script to $.j3wTheme so it can be extended
$.j3wTheme = J3WTheme.prototype;

$(document).ready(function () {

    // Initialize script
    $j3wApp = new J3WTheme();

});
